import React from "react";
import { Helmet } from "react-helmet";
import { useFlags } from "launchdarkly-react-client-sdk";

import CustomerSetting from "components/Screens/SettingV2/Setting";
import AdminSetting from "components/Screens/Setting";
import MangeUsers from "components/Screens/Setting/MangeRoles/ManageUsers";

import { usePermissions } from "components/Hook";

function SettingsV2() {
  const { loggedInUserType } = usePermissions();
  const { anniversaryBasedTimeOff } = useFlags();

  const renderSettingsComponent = () => {
    if (loggedInUserType && loggedInUserType === "edge") {
      return anniversaryBasedTimeOff ? <AdminSetting /> : <MangeUsers />;
    }

    return <CustomerSetting />;
  };

  return (
    <>
      <Helmet>
        <title>Edge | Settings</title>
      </Helmet>
      {renderSettingsComponent()}
    </>
  );
}

export default SettingsV2;
